import React from "react";
import { useNavigate } from "react-router-dom";

import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Box,
  Button,
} from "@mui/material";





function RecentTickets({ tickets }) {

  const navigate = useNavigate();


  const statusStyles = {


    Open:{
      background:"#fef3c7",
      color:"#92400e",
    },


    Assigned:{
      background:"#dbeafe",
      color:"#1d4ed8",
    },


    Closed:{
      background:"#dcfce7",
      color:"#166534",
    },


    Resolved:{
      background:"#dbeafe",
      color:"#1e40af",
    },


    "In Progress":{
      background:"#ede9fe",
      color:"#6d28d9",
    },


  };







  const priorityStyles = {


    Critical:{
      background:"#fee2e2",
      color:"#b91c1c",
    },


    High:{
      background:"#ffedd5",
      color:"#c2410c",
    },


    Medium:{
      background:"#fef9c3",
      color:"#854d0e",
    },


    Low:{
      background:"#dcfce7",
      color:"#166534",
    },


  };







  return(



    <Card

      sx={{
        width:"100%",
        height:"100%",
        maxHeight:380,
        display:"flex",

        borderRadius:3,

        background:"#ffffff",

        border:"1px solid #e5e7eb",

      }}

    >




      <CardContent

        sx={{
          p:2.5,
          display:"flex",
          flexDirection:"column",
          flex:1,

        }}

      >




        <Typography

          variant="h6"

          fontWeight={700}

          sx={{

            color:"#0f172a",

            fontSize:20,

            mb:2,

          }}

        >

          Recent Tickets

        </Typography>







        <TableContainer sx={{ flex:1 }}>



          <Table

            size="small"

          >




            <TableHead>



              <TableRow>


                <TableCell

                  sx={{

                    fontWeight:700,

                    color:"#334155",

                  }}

                >

                  Title

                </TableCell>




                <TableCell

                  sx={{

                    fontWeight:700,

                    color:"#334155",

                  }}

                >

                  Status

                </TableCell>





                <TableCell

                  sx={{

                    fontWeight:700,

                    color:"#334155",

                  }}

                >

                  Priority

                </TableCell>



              </TableRow>



            </TableHead>







            <TableBody>




              {

                tickets?.slice(0,5).map((ticket)=>(



                  <TableRow

                    key={ticket.ticket_id}

                    hover

                    onClick={() => navigate(`/tickets/${ticket.ticket_id}`)}

                    sx={{ cursor: "pointer" }}

                  >




                    <TableCell

                      sx={{

                        color:"#0f172a",

                        fontSize:14,

                        maxWidth:180,

                      }}

                    >

                      {ticket.title}

                    </TableCell>







                    <TableCell>



                      <Chip

                        label={ticket.status}

                        size="small"

                        sx={{

                          background:

                          statusStyles[ticket.status]?.background,


                          color:

                          statusStyles[ticket.status]?.color,


                          fontWeight:600,


                          fontSize:12,


                        }}

                      />



                    </TableCell>









                    <TableCell>



                      <Chip

                        label={ticket.priority}

                        size="small"

                        sx={{

                          background:

                          priorityStyles[ticket.priority]?.background,


                          color:

                          priorityStyles[ticket.priority]?.color,


                          fontWeight:600,


                          fontSize:12,


                        }}

                      />



                    </TableCell>





                  </TableRow>



                ))


              }




            </TableBody>





          </Table>





        </TableContainer>







        <Box

          mt={1}

        >


          <Button

            size="small"

            sx={{

              textTransform:"none",

              color:"#2563eb",

              fontWeight:600,

              fontSize:13,

            }}

          >

            View all tickets →

          </Button>



        </Box>





      </CardContent>




    </Card>



  );

}



export default RecentTickets;